export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/0c7f90dcab4574f291a5b93f31621815.svg";